import {AppStoreState} from 'src/store';

export const CardControlSelectors = {
  getFormState: (state: AppStoreState) => {
    const {formState, id} = state.administration.cardControl;
    return {formState, id};
  },
};
